// extracted by mini-css-extract-plugin
module.exports = {"textLinkInBottomLine":"kvtCWc","place":"W5rHiJ"};